export const ResourceRender = {
	'ResourceType not found.': 'Tipo de recurso no encontrado.',
};
